document.addEventListener('DOMContentLoaded', () => {
  const videos = document.querySelectorAll('.lazy-video');

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        const video = entry.target;

        if (entry.isIntersecting) {

          // Load video sources only once
          if (!video.dataset.loaded) {
            const sources = video.querySelectorAll('source[data-src]');

            if (sources.length) {
              sources.forEach((source) => {
                source.src = source.dataset.src;
              });

              video.load();
              video.dataset.loaded = 'true';
            }
          }

          video.play().catch(() => {});
        } else {
          video.pause();
        }
      });
    },
    {
      rootMargin: '300px'
    }
  );

  videos.forEach((video) => observer.observe(video));
});